/**
 *
 * Asynchronously loads the component for SettingsOrder
 *
 */

import { PageLoading } from 'components/Loading'
import React from 'react'
import loadable from 'utils/loadable'

export default loadable({
  loader: () => import('./index' /* webpackChunkName: "SettingsOrder" */),
  loading: <PageLoading />
})
